<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 16 : 2"
      :class="[`degree-${infoItem.caseSourceId}`,{ 'on-hover': hover }]"
      @click="$emit('card-click',infoItem)"
    >
      <div class="d-flex font-weight-black header-text">
        <div class="pa-3 ml-auto text-c-dark">
          <v-icon
            large
            color="var(--app-primary-color)"
            class="ml-3"
          >
            {{ icon }}
          </v-icon>
          <span class="case-update-card-header"> {{ header }}</span>
        </div>
        <div
          v-if="hasActions"
          class="mt-2"
        >
          <slot
            name="actions"
            :item="infoItem"
          />
        </div>
      </div>

      <template>
        <slot
          name="top-slot"
          :item="infoItem"
        />
      </template>

      <div
        v-if="code"
        class="row px-2 header-text"
      >
        <div class="py-1 text-c-green col-4">
          {{ codeDisplayName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="code"
        >
          {{ code }}
        </div>
      </div>

      <div
        v-if="status"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ statusDisplayName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="status"
        >
          {{ status }}
        </div>
      </div>

      <div
        v-if="date"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ dateDisplayName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="date"
        >
          {{ toHijriDate(date) }}
        </div>
      </div>

      <div
        v-if="type"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ typeDisplayName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="type"
        >
          {{ type }}
        </div>
      </div>
      <div
        v-if="courtName"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ local.home.tabCommon.courtName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="courtName"
        >
          {{ courtName }}
        </div>
      </div>
      <div
        v-if="subCircleName"
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ local.home.tabCommon.subCircleName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="subCircleName"
        >
          {{ subCircleName }}
        </div>
      </div>
      <template>
        <slot
          name="bottom-slot"
          :item="infoItem"
        />
      </template>

      <v-divider class="mt-5 mb-0"></v-divider>

      <div class="d-flex justify-content-end font-weight-black text-c-green">
        <div
          v-if="statusId == ProcedureStatus.inComplete "
          class=""
        >
          <!-- <span class="text-c-lite mr-1">{{ local.caseRelatedProcedure.period(period) }}</span> -->
        </div>
        <div
          v-else
          class="px-2 pa-3"
        >
          <span :class="`degree-text-${infoItem.caseSourceId}`">
            {{ caseDegrees[infoItem.caseSourceId] }} </span>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>

import { toHijriDate, getTimePartArabic } from '@/helpers/utils';
import { caseDegrees, ProcedureStatus } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
import NajButton from '@/components/shared/naj-button/naj-button.vue';
const { mapState, mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'CaseProcedureCard',
  components: { NajButton },
  props: {
    period: {
      type: Number,
      required: true,
    },
    infoItem: {
      default: null,
      type: Object,
      required: true,
    },
    icon: {
      default: null,
      type: String,
      required: true,
    },
    header: {
      default: null,
      type: String,
      required: true,
    },
    codeDisplayName: {
      default: null,
      type: String,
      required: false,
    },
    code: {
      default: null,
      type: [String, Number],
      required: false,
    },
    statusDisplayName: {
      default: null,
      type: String,
      required: false,
    },
    status: {
      default: null,
      type: String,
      required: false,
    },
    statusId: {
      default: null,
      type: Number,
      required: false,
    },
    typeDisplayName: {
      default: null,
      type: String,
      required: false,
    },
    type: {
      default: null,
      type: String,
      required: false,
    },
    dateDisplayName: {
      default: null,
      type: String,
      required: true,
    },
    date: {
      default: null,
      type: String,
      required: true,
    },
    hasActions: {
      default: false,
      type: Boolean,
      required: true,
    },
    subCircleName: {
      default: null,
      type: String,
      required: false,
    },
    courtName: {
      default: null,
      type: String,
      required: false,
    },
    description: {
      default: null,
      type: String,
      required: false,
    },
  },
  data() {
    return {
      caseDegrees,
      ProcedureStatus,
      isLoading: true,
    };
  },
  computed: {
    ...mapState({ userInfo: state => state.userInfo }),
    requestObjectKey() {
      return this.infoItem.objectKey;
    },
  },
  methods: {
    ...mapActions([]),
    getTimePartArabic,
    toHijriDate,
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

.text-c-green {
  color: var(--app-primary-color);
}

.text-c-dark {
  color: var(--app-dark-primary-color);
}

.text-c-lite {
  color: #a6b8bb;
}

.text-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.degree-1 {
  border: 2px solid #97dfdf;

  .degree-text-1 {
    color: #97dfdf;
    font-size: 16px;
    font-weight: bolder;
  }
}

.degree-2 {
  border: 2px solid var(--app-primary-color);

  .degree-text-2 {
    color: var(--app-primary-color);
    font-size: 16px;
    font-weight: bolder;
  }
}

.degree-3 {
  border: 2px solid var(--app-dark-primary-color);

  .degree-text-3 {
    color: var(--app-dark-primary-color);
    font-size: 16px;
    font-weight: bolder;
  }
}
</style>
